import { formatDistanceToNow } from 'date-fns';
import { Loader2 } from 'lucide-react';
import type { SubmissionRow } from '../../types';

const montreal = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Montreal', dateStyle: 'medium', timeStyle: 'short' });

export function SubmissionListView({ submissions, isLoading, onSelect }: {
  submissions: SubmissionRow[];
  isLoading: boolean;
  onSelect: (submission: SubmissionRow) => void;
}) {
  if (isLoading) return <div className="flex justify-center py-12"><Loader2 className="h-5 w-5 animate-spin text-muted-foreground" /></div>;
  if (!submissions.length) return <p className="text-sm text-muted-foreground py-8 text-center">No technician submissions are waiting.</p>;

  return (
    <div className="rounded-lg border bg-card overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-muted text-xs text-muted-foreground">
          <tr>
            <th className="px-3 py-2 text-left font-medium">Plate</th>
            <th className="px-3 py-2 text-left font-medium">Read from plate</th>
            <th className="px-3 py-2 text-left font-medium">Submitted by</th>
            <th className="px-3 py-2 text-left font-medium">Job · site</th>
            <th className="px-3 py-2 text-left font-medium">When</th>
          </tr>
        </thead>
        <tbody className="divide-y">
          {submissions.map((submission) => (
            <tr key={submission.id} className="cursor-pointer hover:bg-muted/50" onClick={() => onSelect(submission)}>
              <td className="px-3 py-2">
                {submission.thumbnailUrl
                  ? <img src={submission.thumbnailUrl} alt="Serial plate" className="h-9 w-12 rounded object-cover bg-muted" loading="lazy" />
                  : <div className="h-9 w-12 rounded bg-muted" />}
              </td>
              <td className="px-3 py-2">
                <div className="font-medium">{submission.brand} {submission.model}</div>
                {submission.candidates.length > 0 && (
                  <div className="text-xs text-amber-700">Similar: {submission.candidates.map((c) => c.label).join(', ')}</div>
                )}
              </td>
              <td className="px-3 py-2">{submission.submittedBy}</td>
              <td className="px-3 py-2 text-muted-foreground">{[submission.jobNumber, submission.siteName].filter(Boolean).join(' · ') || '—'}</td>
              <td className="px-3 py-2 text-muted-foreground" title={montreal.format(new Date(submission.submittedAt))}>
                {formatDistanceToNow(new Date(submission.submittedAt), { addSuffix: true })}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
